module.exports = "<app-input-field\n  [form]=\"form\"\n  type=\"text\"\n  [id]=\"id\"\n  [controlName]=\"controlName\"\n  [key]=\"key\"\n  [class]=\"class\"\n  [minlength]=\"minlength\"\n  [maxlength]=\"maxlength\"\n  [hideErrors]=\"hideErrors\"\n  [hideLabel]=\"hideLabel\"\n  [autofocus]=\"autofocus\"\n></app-input-field>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/borneo/prod/borneo_app/src/app/shared/components/forms/input-text-field/input-text-field.component.html
// module id = ../../../../../src/app/shared/components/forms/input-text-field/input-text-field.component.html
// module chunks = main